// If we ever want to drop to like 5 minute increments, this is how you would do it.
// All in one place. :)
export const SCHEDULER_ROUNDING = 15;
